const imageLoader = (img) =>
  new Promise((resolve) => {
    if (!img) return resolve();
    var src = img;
    var image = new Image();
    image.addEventListener("load", () => {
      resolve();
    });
    image.src = src;
  });

export default imageLoader;
